import Root from "./routes/Root";
import "./FirebaseConfig";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { getPeriods } from "./redux/slices/periods/periodsThunk";
const helmetContext = {};

function App() {
  const dispatch = useAppDispatch();
  const { periods } = useAppSelector((state) => state.periods);

  useEffect(() => {
    if (!periods) {
      dispatch(getPeriods())
    }
  }, [periods]);

  return (
    <HelmetProvider context={helmetContext}>
      <Root />
    </HelmetProvider>
  );
}

export default App;
